module.exports = __webpack_public_path__ + "img/shopTwo.f42fc521.png";